<template>
  <div
    class="stars-select flex c-mt-1"
    :class="[centerStars ? 'justify-center' : 'justify-start', { 'select-small': smallSize }]"
  >
    <i
      v-for="index in 5"
      :key="index"
      :class="[
        index <= starHoverIndex || index <= ratingPickNumber ? 'mi-star-fill': 'mi-star',
        smallSize ? 'icon-20' : 'icon-40',
        { 'mr-n2': index < 5 }
      ]"
      @mouseover="starHoverIndex = index"
      @mouseleave="starHoverIndex = 0"
      @click.prevent="sendStarsRate(index)"
    />
  </div>
</template>

<script setup>
import { ref } from 'vue'

const starHoverIndex = ref(0);

const props = defineProps({
  centerStars: {
    type: Boolean,
    default: true,
  },
  smallSize: {
    type: Boolean,
    default: false,
  },
  ratingPickNumber: {
    type: Number,
    default: 0,
  },
})

const emit = defineEmits(['sendRating'])

const sendStarsRate = (index) => {
  emit('sendRating', index)
}
</script>

<style lang="scss">
.stars-select {
  gap: 0px;

  &.select-small {
    gap: 4px;
  }
}
</style>
